import createBaseRenderer from "./createBaseRenderer";

export default createBaseRenderer({
  name: "doplnkovaSluzba",
  kodKey: "zkratka"
});
